import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// ✅ Your existing Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCkMOzGcXIjJbERMdoO_vkR5Eu-166y-50",
  authDomain: "timewise-in.firebaseapp.com",
  projectId: "timewise-in",
  storageBucket: "timewise-in.firebasestorage.app",
  messagingSenderId: "405965965117",
  appId: "1:405965965117:web:cde384253990d65c9fe754",
  measurementId: "G-EQXMQR882L",
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// ✅ Initialize messaging
const messaging = getMessaging(app);

// ✅ Function to get token
const getFcmToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted.");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey:
        "BCSk3bxsek76Ns9vp7afHLjpkHoJYQHLIfpVjZPSc7JMM_zbWl3JtS1X1CFl-wdZMZ340IZix8YdnebRYJH6Sbk", // ⬅️ Replace with your actual key
    });

    console.log("✅ FCM Token:", token);
    return token;
  } catch (error) {
    console.error("❌ Error getting FCM token:", error);
    return null;
  }
};

// ✅ Listen to foreground messages
const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, resolve);
  });

export { app, auth, messaging, getFcmToken, onMessageListener };
